export default "M 19 15.6 L 4.9 1.6 L 4.9 15.6 L 19 15.6 Z M 3.4 0 L 20.5 0 L 20.54 24 L 3.4 24 L 3.4 0 Z";